import React from "react";
import { Link, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Home, Compass, Search } from "lucide-react";
import { useStore } from "../context/StoreContext";

export default function BottomNav() {
    const { setSearchOpen, cartOpen, searchOpen } = useStore();
    const location = useLocation();
    const hidden =
        cartOpen ||
        searchOpen ||
        location.pathname.startsWith("/checkout") ||
        location.pathname.startsWith("/payment");

    const items = [
        { icon: Home, to: "/", testid: "bottom-nav-home", active: location.pathname === "/" },
        { icon: Compass, to: "/shop", testid: "bottom-nav-shop", active: location.pathname.startsWith("/shop") },
    ];

    return (
        <AnimatePresence>
            {!hidden && (
                <motion.nav
                    data-testid="bottom-nav"
                    initial={{ y: 90, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 90, opacity: 0 }}
                    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay: 0.4 }}
                    className="fixed bottom-4 left-1/2 z-[115] -translate-x-1/2 md:hidden"
                >
                    <div className="flex items-center gap-1 rounded-full border border-[rgba(10,10,10,0.14)] bg-[rgba(242,240,234,0.8)] px-2.5 py-2 shadow-[0_20px_50px_-12px_rgba(0,0,0,0.25)] backdrop-blur-xl">
                        {items.map(({ icon: Icon, to, testid, active }) => (
                            <Link
                                key={testid}
                                data-testid={testid}
                                to={to}
                                aria-label={testid}
                                className={`flex h-11 w-11 items-center justify-center rounded-full transition-colors duration-300 ${
                                    active ? "bg-[#0A0A0A] text-[#F2F0EA]" : "text-[#8E8D8A]"
                                }`}
                            >
                                <Icon size={17} strokeWidth={1.8} />
                            </Link>
                        ))}
                        <button
                            data-testid="bottom-nav-search"
                            onClick={() => setSearchOpen(true)}
                            aria-label="Search"
                            className="flex h-11 w-11 items-center justify-center rounded-full text-[#8E8D8A] transition-colors duration-300"
                        >
                            <Search size={17} strokeWidth={1.8} />
                        </button>
                    </div>
                </motion.nav>
            )}
        </AnimatePresence>
    );
}
